import { generateEndpoint } from '@ngtrvu/use-api';
import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_NOTIFICATION_LOG_LIST_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_NOTIFICATION_LOG_LIST_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_NOTIFICATION_LOG_LIST_API_ID,
  ({ id, ...params }: { id?: string } & Record<string, any>) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/notification-logs`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
